import { useState } from "react";
import api from "../../api";
import { OrderType, TimeInForce } from "../../api/enums";
import { BrokerOrder, ReplaceOptionsOrderRequest } from "../../api/orders";

export const useEditOptionsOrderForm = ({
  order,
  onSuccess,
  onError,
} : {
  order: BrokerOrder,
  onSuccess?: () => void,
  onError?: (e: any) => void,
}) => {

  const limitEditable = order.order_type !== null && [
    OrderType.Limit, OrderType.StopLimit
  ].includes(order.order_type);

  const stopEditable = order.order_type !== null && [
    OrderType.Stop, OrderType.StopLimit, OrderType.StopTrail
  ].includes(order.order_type);

  const [tif, setTif] = useState<TimeInForce>(order.time_in_force || TimeInForce.GoodTillCancelled);
  const [quantity, setQuantity] = useState<number>(order.quantity || 0);
  const [limitPrice, setLimitPrice] = useState<number>(order.limit_price || 0);
  const [stopPrice, setStopPrice] = useState<number>(order.stop_price || 0);

  const [error, setError] = useState<any>(null);
  const [submitting, setSubmitting] = useState<boolean>(false);

  const submit = async () => {

    try {

      setError(null);
      setSubmitting(true);
      const request : ReplaceOptionsOrderRequest = {
        time_in_force: tif,
        quantity: quantity,
        limit_price: limitEditable ? limitPrice : undefined,
        stop_price: stopEditable ? stopPrice : undefined,
        order_type: order.order_type!,
      }
      await api.orders.replaceOptionsOrder(order.broker_order_id, request);
      if (onSuccess) {
        onSuccess();
      }

    } catch (e) {

      setError(e);
      if (onError) {
        onError(e);
      }

    } finally {

      setSubmitting(false);

    }
  }

  return {
    limitEditable, limitPrice, setLimitPrice,
    stopEditable, stopPrice, setStopPrice,
    tif, setTif,
    quantity, setQuantity,
    error, submitting,
    submit,
  }
}